@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.iconWrapper {
  display: flex;

  svg {
    fill: var(--icon-default);
  }
}

.mainLabel {
  color: var(--text-default);
  white-space: nowrap;
  @include typography-v2-body-base;
  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 1;

  &.isJapanese {
    @include typography-v2-body-sm;
  }

  &.isAlfred.isJapanese {
    @include respond-to('max-xl') {
      @include typography-v2-ui-xs;
    }
  }
}

.itemWrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: inline-block;
}

.buttonItem {
  @include typography-v2-body-xs;
  @include border-radius-r2;
  position: relative;
  display: flex;
  background: none;
  border: none;
  cursor: pointer;
  outline: none;
  height: 32px;
  padding: 0 4px;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus-visible {
    .mainLabel {
      color: var(--text-primary);
    }
  }

  &.isAlfred {
    @include typography-v2-ui-base;
    width: 102px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.isLoadingSize {
      width: 100px;
      height: 34px;
    }

    &.isJapanese {
      width: 122px;

      &.isLoadingSize {
        width: 120px;
      }

      @include respond-to('xxl') {
        width: 140px;
      }
    }
  }

  &.pillStyle {
    border-radius: 100px;
    background-color: var(--surface-active);

    &:hover {
      background-color: var(--surface-hover);

      svg,
      svg path {
        fill: var(--icon-primary);
      }
    }
  }

  &.isActive {
    .mainLabel {
      color: var(--text-primary);
    }

    svg {
      fill: var(--icon-primary);

      path {
        fill: var(--icon-primary);
      }
    }
  }

  &.disabled {
    cursor: default;
    pointer-events: none;
  }

  @include respond-to('xlg') {
    padding: 0 8px;
  }
}

.itemLeft {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.notificationWrapper {
  position: absolute;
  z-index: var(--z-tooltip);
}

.styledDropdown {
  width: 135px;
  min-width: 135px;
  max-width: 135px;
  margin-right: 12px;
  @include border-radius-r2;
}

.styledCustomDropdown {
  min-width: unset;
  max-width: unset;
  padding: 0;
  gap: 0;
  @include border-radius-r2;
}
